import * as MOCK_STAT_WITH_FEATURE from './mockwithfeature.store.json';

export { MOCK_STAT_WITH_FEATURE };
